import type { FC, SVGProps } from 'react';

const SignTurnSlightRightIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.83497 6.98212L9.63504 8.36788C9.74102 8.55144 10.013 8.52811 10.0862 8.32918L11.1464 5.44662C11.2003 5.30009 11.1082 5.14056 10.9544 5.11397L7.92789 4.5909C7.71902 4.5548 7.56282 4.77869 7.6688 4.96225L8.3349 6.11597L7.71377 6.48865C6.96076 6.94046 6.50001 7.75422 6.50001 8.63238V11H7.50001V8.63238C7.50001 8.10549 7.77646 7.61723 8.22826 7.34614L8.83497 6.98212Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.45059 0.434678C8.03017 -0.144894 8.96984 -0.144892 9.54941 0.434679L16.0653 6.95059C16.6449 7.53017 16.6449 8.46984 16.0653 9.04941L9.54941 15.5653C8.96983 16.1449 8.03016 16.1449 7.45059 15.5653L0.934678 9.04941C0.355106 8.46983 0.355108 7.53016 0.934679 6.95059L7.45059 0.434678ZM8.8498 1.13428C8.65661 0.941093 8.34339 0.941093 8.1502 1.13428L1.63428 7.6502C1.44109 7.84339 1.44109 8.15661 1.63428 8.3498L8.1502 14.8657C8.34339 15.0589 8.65661 15.0589 8.8498 14.8657L15.3657 8.3498C15.5589 8.15661 15.5589 7.84339 15.3657 7.6502L8.8498 1.13428Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SignTurnSlightRightIcon;
